<template>
  <div>
    <v-dialog
      v-model="messagePopupDialog"
      full-width
      :max-width="maxWidth ? maxWidth : 400"
    >
      <v-btn
        :color="color"
        slot="activator"
        block
      >
        <v-icon left>
          mail_outline
        </v-icon>
        {{ buttonText }}
      </v-btn>
      <v-card>
        <v-card-title>
          <h1 class="subheading">New Message {{ recipientName ? ` to ${ recipientName }` : '' }}</h1>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <v-text-field
            label="Subject"
            v-model="messageSubject"
          >
          </v-text-field>
          <v-textarea
            label="Body"
            v-model="messageBody"
            box
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat small @click="closeDialog">Nevermind</v-btn>
          <v-btn color='success' small :loading="apiCallPending" @click="sendMessage" :disabled="!messageValid || !recipientId">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import messageApi from '@/api/messages'

export default {
  props: [
    'color',
    'buttonText',
    'maxWidth',
    'recipientId',
    'senderId',
  ],
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    messageValid: function () {
      if (
        this.messageBody &&
        this.recipientId &&
        this.senderId
      ) {
        return true
      } else {
        return false
      }
    },
  },
  created () {
  },
  watch: {
    'messagePopupDialog' : 'dialogChanged'
  },
  data: function () {
    return {
      messagePopupDialog: false,
      apiCallPending: false,
      recipientName: '',
      messageSubject: '',
      messageBody: '',
    }
  },
  methods: {
    dialogChanged (opened) {
      if (opened) {
        this.getData()
      } else {
        this.clearMessage()
      }
    },
    getData () {
      messageApi.getRecipientName(
        this.recipientId,
      recipient => {
        this.recipientName = recipient.name
      },
      error => {
        console.log('error getting recipient name')
      })
    },
    sendMessage () {
      this.apiCallPending = true
      messageApi.create({
        senderId: this.senderId,
        recipientIds: [this.recipientId],
        subject: this.messageSubject,
        message: this.messageBody,
      },
      recipient => {
        this.apiCallPending = false
        this.closeDialog()
        const message = `Message to ${ this.recipientName } sent!`
        this.$store.dispatch('global/showSnackbarSuccess', { message: message })
      },
      error => {
        this.apiCallPending = false
        this.closeDialog()
        const message = `There was a problem sending that message...`
        this.$store.dispatch('global/showSnackbarError', { message: message })
      })
    },
    clearMessage () {
    },
    closeDialog () {
      this.messagePopupDialog = false
    },
  },
}
</script>

<style scoped>
</style>
